import { useEffect, useState } from 'react';

/** Observes refs and increments a tick whenever any element resizes. rAF-debounced so multiple
 * sibling resizes coalesce into a single tick per frame. Pass refs that should re-trigger fits. */
const useResizeTick = (
  refs: Array<React.RefObject<Element | null>>,
  resetKey?: unknown
) => {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const elements = refs
      .map((ref) => ref.current)
      .filter((element): element is Element => element !== null);
    if (elements.length === 0) return;

    let animationFrameId = 0;
    const resizeObserver = new ResizeObserver(() => {
      cancelAnimationFrame(animationFrameId);
      animationFrameId = requestAnimationFrame(() => {
        setTick((previous) => previous + 1);
      });
    });
    elements.forEach((element) => resizeObserver.observe(element));
    return () => {
      cancelAnimationFrame(animationFrameId);
      resizeObserver.disconnect();
    };
  }, [resetKey]);

  return tick;
};

export default useResizeTick;
